import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    technologyList: [],
    technology: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
      tab: null,
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.technologyList = [];
      state.technology = null;
      state.tab = null;
    },
    SET_TECHNOLOGYLIST(state, data) {
      state.technologyList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_TECHNOLOGY(state, data) {
      state.technology = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setTechnology({ commit }, data) {
      commit('SET_TECHNOLOGY', data);
    },

    find({ commit, state }) {
      let url = `/technology?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('technology'));
          return response.body;
        })
        .then((response) => {
          commit('SET_TECHNOLOGYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/technology/${id}`)
        .then((response) => response.body)
        .then(typeAs('technology'))
        .then((item) => {
          commit('SET_TECHNOLOGY', item);
        });
    },

    destroy(_, id) {
      return http(`/technology/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/technology/${id}`, { method: 'PUT', data })
        : http('/technology', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/technology/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
    // 取得所屬技術類別
    getTechCates(_, id) {
      const request = id
        ? http(`/techcatebyID/${id}`)
        : http('/techcates/all');
      return request.then((response) => response.body);
    },
  },
};
